import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-email-sms-popup',
    templateUrl: './email-sms-popup.component.html',
    styleUrls: ['./email-sms-popup.component.scss'],
    standalone: false
})
export class EmailSmsPopupComponent {
  @Input() emailBox: string = '';
  @Input() phoneNumber: string = '';
  @Input() emailPattern: string = "^[^@]+@[a-zA-Z0-9._-]+\\.+[a-zA-Z._-]+$";

  @Output() onSubmit = new EventEmitter<{
  email: string;
  phone: string;
  emailSelected: boolean;
  smsSelected: boolean;
}>();

  emailCheckBox: boolean = true;
  isSMSChecked: boolean = false;
  enableEmail: boolean = true;
  enablesms: boolean = false;
  
  PhoneNumberMask: string = "(000)-000-0000";
   ngOnChanges(): void {  
    this.updateEmailandSmsFlags();
  }
  updateEmailandSmsFlags() {
    this.emailCheckBox = this.enableEmail = Boolean(this.emailBox && this.emailBox.trim() !== '');
    this.isSMSChecked = this.enablesms = Boolean(this.phoneNumber && this.phoneNumber.trim() !== '');
  }

  sendEmailandsms() {
    this.onSubmit.emit({
      email: this.emailBox,
      phone: this.phoneNumber,
      emailSelected: this.emailCheckBox,
      smsSelected: this.isSMSChecked
    });
  }
disabledEmailSmsOkButton(): boolean {
  let isEmailInvalid = false;
  let isSmsInvalid = false;
 if (this.emailCheckBox) {
    const emailPattern = new RegExp(this.emailPattern);
    isEmailInvalid = !this.emailBox || !emailPattern.test(this.emailBox);
  }
  if (this.isSMSChecked) {
    const digitsOnly = this.phoneNumber ? this.phoneNumber.replace(/\D/g, '') : '';
    isSmsInvalid = digitsOnly.length !== 10;
  }
  return (!this.emailCheckBox && !this.isSMSChecked) || isEmailInvalid || isSmsInvalid;
}

  onkeysms(event: any) {
    this.phoneNumber = event.target.value;
  }
}
